/**
 * Created by jonas on 2020-08-13.
 */
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";


export class KitchenDramaSushiManiaGameMode extends GameMode {
    public static readonly WILD_SUSHI:string = "WILD_SUSHI";
}